import { render, staticRenderFns } from "./BottomSideComponent.vue?vue&type=template&id=6f867fd5&scoped=true&"
import script from "./BottomSideComponent.vue?vue&type=script&lang=js&"
export * from "./BottomSideComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f867fd5",
  null
  
)

export default component.exports